export type FeatureDefinition = {
  name: string;
  action: string;
  isMainView?: boolean;
  isRootLevel?: boolean;
  route?: string;
  needs?: string;
  auto?: readonly string[];
  standAloneFeature?: boolean;
  routeParams?: Record<string, string>;
};

export default [
  {
    name: 'viewDepotLandingPage',
    isMainView: true,
    isRootLevel: true,
    route: 'depotLanding',
    action: 'r:depot-landing-page'
  },
  {
    name: 'viewLiveStatus',
    action: 'r:tour',
    isMainView: true,
    isRootLevel: true,
    route: 'liveStatus'
  },
  {
    name: 'liveStatusMapEnabled',
    action: 'r:live-status-map',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailView',
    action: 'r:tour-details',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailViewDevice',
    action: 'r:tour-device',
    needs: 'r:tour-details'
  },
  {
    name: 'tourDetailViewDriverLocation',
    action: 'r:tour-details-driver-location',
    needs: 'r:tour-details'
  },
  {
    name: 'viewUsageAnalysis',
    action: 'r:tour-activity',
    isMainView: true,
    isRootLevel: true,
    route: 'dailyActivities'
  },
  {
    name: 'viewUsageAnalysisFull',
    action: 'r:tour-activity-full',
    needs: 'r:tour-activity'
  },
  {
    name: 'tourDrivenHistory',
    action: 'r:tour-location-history',
    needs: 'r:tour-activity'
  },
  {
    name: 'readTourActivity',
    action: 'r:rtt',
    needs: 'r:tour-activity'
  },
  {
    name: 'viewTourRecommendations',
    action: 'r:tour-activity-recommendations',
    needs: 'r:rtt'
  },
  {
    name: 'viewTourPerformance',
    action: 'r:tour-perf',
    isMainView: true,
    isRootLevel: true,
    route: 'tourPerformance'
  },
  {
    name: 'viewDepotDashboard',
    action: 'r:rtt-dashboard',
    isMainView: true,
    isRootLevel: true,
    route: 'depotDashboard'
  },
  {
    name: 'viewLoadingDispatchDashboard',
    action: 'r:loading-dispatch-dashboard',
    isMainView: true,
    isRootLevel: true,
    route: 'loadingAndDispatchDashboard'
  },
  {
    name: 'viewCollectionsCockpit',
    action: 'r:depot-collections-cockpit',
    isMainView: true,
    isRootLevel: true,
    route: 'collectionsCockpit'
  },
  {
    name: 'viewDevices',
    action: 'r:device',
    isMainView: true,
    isRootLevel: true,
    route: 'deviceManagement'
  },
  {
    name: 'readUploadJobs',
    action: 'r:upload-jobs',
    isMainView: true,
    isRootLevel: true,
    route: 'uploadJobs'
  },
  {
    name: 'readHealthStatus',
    action: 'r:health-status',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'readSmartInsights',
    action: 'r:smart-insights',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'lastMeterEnabled',
    action: 'r:last-meter-locations',
    isRootLevel: true
  },
  {
    name: 'viewSubcontractors',
    action: 'r:suco',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractor'
  },
  {
    name: 'createSubcontractor',
    action: 'c:suco',
    needs: 'r:suco'
  },
  {
    name: 'updateSubcontractorCompany',
    action: 'u:suco',
    needs: 'r:suco'
  },
  {
    name: 'deleteSubcontractorCompany',
    action: 'd:suco',
    needs: 'r:suco'
  },
  {
    name: 'viewDrivers',
    action: 'r:driver',
    needs: 'r:suco'
  },
  {
    name: 'deleteDriver',
    action: 'd:driver',
    needs: 'r:driver'
  },
  {
    name: 'createDriver',
    action: 'c:driver',
    needs: 'r:driver'
  },
  {
    name: 'updateDriver',
    action: 'u:driver',
    needs: 'r:driver'
  },
  {
    name: 'readBOUsers',
    action: 'r:bo-user',
    isMainView: true,
    isRootLevel: true,
    route: 'backofficeUsers'
  },
  {
    action: 'c:bo-user',
    name: 'createBOUser',
    needs: 'r:bo-user'
  },
  {
    action: 'u:bo-user',
    name: 'updateBOUsers',
    needs: 'r:bo-user'
  },
  {
    name: 'deleteUser',
    action: 'd:bo-user',
    needs: 'r:bo-user'
  },
  {
    name: 'viewTempDrivers',
    action: 'r:temp-driver',
    isMainView: true,
    isRootLevel: true,
    route: 'tempDrivers'
  },
  {
    name: 'deleteTempDriver',
    action: 'd:temp-driver',
    needs: 'r:temp-driver'
  },
  {
    name: 'createTempDriver',
    action: 'c:temp-driver',
    needs: 'r:temp-driver'
  },
  {
    name: 'updateTempDriver',
    action: 'u:temp-driver',
    needs: 'r:temp-driver'
  },
  {
    name: 'activateDriver',
    action: 'activate-user',
    needs: 'r:temp-driver'
  },
  {
    name: 'deactivateDriver',
    action: 'deactivate-user',
    needs: 'r:temp-driver'
  },
  {
    name: 'tourDrivenHistory',
    action: 'r:tour-location-history',
    needs: 'r:tour-activity'
  },
  {
    name: 'readBetterPlanner',
    action: 'r:better-planner',
    isMainView: false,
    isRootLevel: true
  },
  {
    name: 'viewAddressLocationValidation',
    action: 'r:address-location-correction',
    isMainView: true,
    isRootLevel: true,
    route: 'addressLocationValidation'
  },
  {
    name: 'canAssignPermission',
    action: 'can-assign-permission',
    auto: [
      'c:bo-user',
      'u:bo-user',
      'c:temp-driver',
      'u:temp-driver',
      'c:driver',
      'u:driver'
    ]
  }
] as const satisfies readonly FeatureDefinition[];
